<template>
  <footer class="dd-footer">
    <p>
      <span>广州数鸽科技有限公司 版权所有</span>
      <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备15042289号</a>
      <a :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${num}`" target="_blank" rel="noopener noreferrer"><img src="https://cdn.jin10.com/assets/img/commons/gonganbeian.png" alt="" style="height: 17px;">粤公网安备{{num}}号</a>
    </p>
    <p>Copyright &#169; 2019 - 现在 All Rights Reserved</p>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      num: window.gaNumber || '44010502003708'
    }
  },
}
</script>

<style lang="scss">
.dd-footer {
  padding: 57px 0;
  text-align: center;
  color: #fff;
  font-size: 17px;

  p {
    margin: 1em;
    &:first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }
  }
  a {
    color: inherit;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    
    &:hover {
      text-decoration: underline;
    }
  }
  @include media-tablet {
    font-size: 11px;
  }
}
</style>
